/**
 * Created by olga on 27.09.2024
 */

const Fixable = function (unit) {
    UnitComponent.call(this, unit); 
};

Fixable.prototype = Object.create(UnitComponent.prototype);
Fixable.prototype.constructor = Fixable;

Fixable.prototype.updateStage = function (f) {
    if (this.unit.isLast()) {
        f();
        return;
    }

    const x = this.unit.x;
    const y = this.unit.y;
    const newUnit = new Unit({
        code: this.unit.code,
        stage: this.unit.stage + 1
    });

    const previousStageImage = this.unit.onGetView().sprite;
    previousStageImage.setVisible(false);
    cleverapps.persist.sendNode(previousStageImage, "PreviousStageImage");

    newUnit.setPosition(x, y);
    Map2d.currentMap.onAddUnit(x, y, newUnit);
    Map2d.currentMap.add(Map2d.LAYER_UNITS, x, y, newUnit);
    Map2d.currentMap.onUnitAvailable(newUnit);

    const regionControl = newUnit.findComponent(RegionControl);
    if (regionControl) {
        regionControl.afterUpgradeStage(f);
    } else {
        newUnit.findComponent(Fixable).afterUpgradeStage(f);
    }
};

Fixable.prototype.afterUpgradeStage = function (f) {
    this.view.afterUpgradeStage(f);
};
